module.exports = __webpack_public_path__ + "media/images/moov-9f102a246b639751fd6577e4cbcc416a.png";